import { Routes } from '@angular/router';

export const miarearoutes: Routes = [
  { path: 'distributor', loadChildren: () => import('./my-distributor/my-distributor.module').then(m => m.MyDistributorModule), data: { animation: 'distributor', roles: ['ADMINISTRADOR', 'LEAPMOTOR', 'RESPONSABLE MARKETING', 'GERENTE'] } }
]
